import React, {useEffect, useRef} from 'react';
import {Navigate} from 'react-router-dom';
import {enqueueSnackbar} from 'notistack';
import {usePermissions} from './PermissionContext';
import {PermissionCodeType} from './permissions';

interface PermissionGuardProps {
  children: React.ReactNode;
  permission?: PermissionCodeType | string;
  anyOf?: Array<PermissionCodeType | string>;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({children, permission, anyOf}) => {
  const {loading, hasPermission, hasAnyPermission} = usePermissions();
  const notified = useRef(false);

  const allowed = permission
    ? hasPermission(permission)
    : hasAnyPermission(...(anyOf ?? []));

  useEffect(() => {
    if (loading || allowed || notified.current) {
      return;
    }
    notified.current = true;
    enqueueSnackbar("You don't have access to that page.", {variant: 'warning', autoHideDuration: 4000});
  }, [loading, allowed]);

  if (loading) {
    return null;
  }

  if (!allowed) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default PermissionGuard;
